class RoundImageLinks extends HTMLElement {
  connectedCallback() {
    this.storyList = this.querySelector('[data-round-image-links-story-list]');
    this.buttonNext = this.querySelector('[data-round-image-links-button-next]');
    this.buttonPrevious = this.querySelector('[data-round-image-links-button-previous]');

    this.storyList.addEventListener('scroll', this.updateEdge.bind(this));
    this.updateEdge();

    this.buttonNext.addEventListener('click', this.scrollToRight.bind(this));
    this.buttonPrevious.addEventListener('click', this.scrollToLeft.bind(this));
  }

  updateEdge() {
    if (this.storyList.scrollLeft === 0) {
      this.setAttribute('data-round-image-links-edge-reached-left', '');
    } else {
      this.removeAttribute('data-round-image-links-edge-reached-left');
    }

    if (this.storyList.scrollLeft + this.storyList.clientWidth >= this.storyList.scrollWidth) {
      this.setAttribute('data-round-image-links-edge-reached-right', '');
    } else {
      this.removeAttribute('data-round-image-links-edge-reached-right');
    }
  }

  scrollToRight() {
    this.storyList.scrollTo({
      left: this.storyList.scrollLeft + this.storyList.clientWidth,
      behavior: 'smooth',
    });
  }

  scrollToLeft() {
    this.storyList.scrollTo({
      left: this.storyList.scrollLeft - this.storyList.clientWidth,
      behavior: 'smooth',
    });
  }
}

customElements.define('round-image-links', RoundImageLinks);